/***
 *
 *   ACCOUNT
 *   Index page for account functions
 *
 **********/

import { useContext, useEffect } from "react";
import {
  AuthContext,
  Animate,
  Grid,
  Card,
  Button,
  Icon,
  Loader,
  useAPI,
} from "components/lib";

export function Account() {
  const context = useContext(AuthContext);

  const user = useAPI("/api/user");
  const iconSize = 20;

  // Prevent horizontal scroll on mount
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflowX = 'hidden';
    return () => {
      document.body.style.overflowX = 'auto';
      document.documentElement.style.overflowX = 'auto';
    };
  }, []);

  if (user.loading) return <Loader />;

  return (
    <div className="min-h-screen w-full overflow-x-hidden" style={{ maxWidth: '100vw' }}>
      <div 
        className="py-3 w-full box-border px-6 sm:px-6 sm:pr-6 overflow-x-hidden"
        style={{ 
          width: window.innerWidth < 640 ? 'calc(100vw - 24px)' : 'calc(100vw - 256px - 24px)',
          maxWidth: window.innerWidth < 640 ? 'calc(100vw - 24px)' : 'calc(100vw - 256px - 24px)'
        }}
      >
        <Animate>
          <Grid max={2}>
            <Card variant="mini">
              <Icon name="user" size={iconSize} />

              <h1>Profile</h1>
              <span>Update your profile information</span>

              <Button
                size="xs"
                color="glassBlue"
                url="/account/profile"
                text="Edit Profile"
              />
            </Card>

            <Card>
              <Icon name="lock" size={iconSize} />

              <h1>Password</h1>
              <span>
                {user?.data?.["has_password"]
                  ? "Change your password"
                  : "Create a password"}
              </span>

              <Button
                size="xs"
                color="glassGreen"
                url="/account/password"
                text={
                  user?.data?.["has_password"]
                    ? "Change Password"
                    : "Create Password"
                }
              />
            </Card>

            <Card>
              <Icon name="fingerprint" size={iconSize} />

              <h1>Two-Factor Authentication</h1>
              <span>Add an extra layer of security</span>

              <Button
                size="xs"
                color="glassPurple"
                url="/account/2fa"
                text={
                  user?.data?.["2fa_enabled"]
                    ? "Manage 2FA"
                    : "Enable 2FA"
                }
              />
            </Card>

            {context.permission?.owner && (
              <Card>
                <Icon name="credit-card" size={iconSize} />

                <h1>Billing</h1>
                <span>Manage your subscription and billing</span>

                <Button
                  size="xs"
                  color="glassOrange"
                  url="https://billing.stripe.com/p/login/dRm5kE5VwdiReMC9AI93y00"
                  text="Manage Billing"
                />
              </Card>
            )}

            <Card>
              <Icon name="bell" size={iconSize} />

              <h1>Notifications</h1>
              <span>Configure your notification preferences</span>

              <Button
                size="xs"
                color="glassPink"
                url="/account/notifications"
                text="Manage Notifications"
              />
            </Card>

        {/* {context.permission?.developer && (
          <Card>
            <Icon name="key-round" size={iconSize} />

            <h1>{t("account.api_keys.title")}</h1>
            <span>{t("account.api_keys.description")}</span>

            <Button
              size="xs"
              variant="outline"
              url="/keys"
              text={t("account.api_keys.button")}
            />
          </Card>
        )}*/}

            {context.permission?.admin && (
              <Card>
                <Icon name="users" size={iconSize} />

                <h1>Users</h1>
                <span>Manage team members and permissions</span>

                <Button
                  size="xs"
                  color="glassBlue"
                  url="/account/users"
                  text="Manage Users"
                />
              </Card>
            )} 
          </Grid>
        </Animate>
      </div>
    </div>
  );
}
